"use client";
import { jsxs as t, jsx as e } from "react/jsx-runtime";
const c = ({
  title: r,
  titleId: i,
  desc: n,
  descId: o,
  ...l
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": i,
    "aria-describedby": o,
    ...l,
    children: [
      n ? /* @__PURE__ */ e("desc", { id: o, children: n }) : null,
      r ? /* @__PURE__ */ e("title", { id: i, children: r }) : null,
      /* @__PURE__ */ e(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "M20.5653 12.5776c.241-.199.3615-.2985.4056-.4169a.458.458 0 0 0 0-.3214c-.0441-.1184-.1646-.2179-.4056-.4169l-8.3631-6.9043c-.4149-.3425-.6224-.5138-.798-.518-.1526-.0036-.2984.061-.3949.175-.111.1312-.111.3943-.111.9206v4.0845c-2.1075.355-4.0364 1.3837-5.4699 2.9281C3.8658 13.792 3.0012 15.971 3 18.2295v.5819c1.036-1.202 2.3295-2.1742 3.792-2.8499 1.2893-.5958 2.683-.9487 4.1063-1.0417v3.9845c0 .5263 0 .7895.111.9206.0965.114.2423.1786.3949.175.1756-.0042.3831-.1755.798-.518z"
        }
      )
    ]
  }
);
export {
  c as default
};
